export const tipsPaneHeader = "VT2Iac";
export const editorPaneHeader = "k0Thub";
export const helpPaneHeader = "W5WMjc";
export default {tipsPaneHeader,editorPaneHeader,helpPaneHeader};